(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // "Shop" mega menu: shared open/close helpers so outside-click and hover
  // (below) both get the same smooth close — a plain removeAttribute('open')
  // on a native <details> hides its content immediately (before the CSS
  // opacity/transform transition in component-mega-menu.css gets a chance
  // to run), which is why closing used to snap instantly while opening
  // looked fine. Closing here instead fades the content out first (via
  // .mega-menu--closing, see component-mega-menu.css) and only removes
  // 'open' once that transition actually finishes, so the same 0.25s
  // animation plays both ways.
  const shopDetails = document.getElementById('Details-HeaderCategories');
  const shopSummary = shopDetails ? shopDetails.querySelector('summary') : null;
  const shopContent = shopDetails ? shopDetails.querySelector('.mega-menu__content') : null;
  let shopCloseTimer = null;

  function openShopMenu() {
    if (!shopDetails) return;
    clearTimeout(shopCloseTimer);
    shopDetails.classList.remove('mega-menu--closing');
    shopDetails.setAttribute('open', '');
    if (shopSummary) shopSummary.setAttribute('aria-expanded', 'true');
  }

  function closeShopMenu() {
    if (!shopDetails || !shopDetails.hasAttribute('open')) return;
    if (shopSummary) shopSummary.setAttribute('aria-expanded', 'false');
    clearTimeout(shopCloseTimer);

    if (!shopContent) {
      shopDetails.removeAttribute('open');
      return;
    }

    shopDetails.classList.add('mega-menu--closing');
    const finishClose = () => {
      shopDetails.removeAttribute('open');
      shopDetails.classList.remove('mega-menu--closing');
    };
    // Timeout backup alongside transitionend — transitionend can fail to
    // fire (e.g. reduced-motion stripping the transition, or the pointer
    // re-entering and CSS recalculating mid-flight), which would otherwise
    // leave 'open' stuck forever.
    shopContent.addEventListener('transitionend', finishClose, { once: true });
    shopCloseTimer = setTimeout(finishClose, 300);
  }

  // Close on outside click. Escape-to-close and focusout-to-close (focus
  // moving to another focusable element) already come from global.js /
  // details-disclosure.js, which cover keyboard and tab-away cases — but a
  // click on a non-focusable part of the page (plain text, background)
  // doesn't move focus at all, so it never triggered either of those.
  // Scoped to this one details id only, so it doesn't change behavior for
  // the theme's other header-menu instances (header-dropdown-menu /
  // header-mega-menu).
  document.addEventListener('click', (event) => {
    if (!shopDetails || !shopDetails.hasAttribute('open')) return;

    const shopMenu = shopDetails.closest('header-menu');
    if (shopMenu && shopMenu.contains(event.target)) return;

    closeShopMenu();
  });

  // Open/close on click only (previously also opened/closed on hover) —
  // summary's own native click-to-toggle is intercepted (preventDefault)
  // and replaced with the SAME openShopMenu/closeShopMenu pair the
  // outside-click handler above already uses, so the smooth fade
  // animation plays consistently regardless of how the menu opens/closes,
  // instead of the browser's native instant toggle. Scoped to this one
  // details id only, same as the outside-click handler above, so the
  // theme's other header-menu instances keep their own default behavior.
  if (shopDetails && shopSummary) {
    shopSummary.addEventListener('click', (event) => {
      event.preventDefault();
      if (shopDetails.hasAttribute('open')) {
        closeShopMenu();
      } else {
        openShopMenu();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
